import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Facsimile } from "../../types"
import ParatestoForm from "./ParatestoForm"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { initialValuesParatesto, validationSchemaParatesto } from "./ParatestoCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { useMemo } from "react"
import { useParatesto, useParatestoDelete, useParatestoUpdate } from "../../hooks/paratesti"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function ParatestoUpdate() {
  const updateParatesto = useParatestoUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: paratesto } = useParatesto(Number(id))

  const [modalStateDeleteParatesto, modalActionsDeleteParatesto] = useModalTrigger()

  const deleteParatesto = useParatestoDelete()

  const initialValues = useMemo(() => initialValuesParatesto(paratesto), [paratesto])
  const validationSchema = useMemo(() => validationSchemaParatesto(true), [])

  useBreadcrumbs([{ label: "Paratesti", href: "/edizioni/paratesti" }, { label: "Dettaglio Paratesto" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1 style={{
            maxWidth: '70%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
            <span dangerouslySetInnerHTML={{ __html: paratesto?.titolo || "" }} />
          </H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteParatesto.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return updateParatesto.mutateAsync(values as Facsimile).then(() => {
                navigate(`/edizioni/paratesti`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <ParatestoForm showEdizione col={8} />
                </Container>
                <BottomFormFixed url="/edizioni/paratesti" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteParatesto.isOpen}
        onClose={modalActionsDeleteParatesto.close}
        onDelete={() => {
          return deleteParatesto.mutateAsync(paratesto?.id).then(() => {
            navigate(`/edizioni/paratesti`)
          })
        }}
        message="Sei sicuro di voler eliminare questo paratesto?"
        title="Elimina paratesto"
      />
    </Layout>
  )
}
